import DOMPurify from 'dompurify';

const SANITIZE_OPTIONS: DOMPurify.Config = {
    ALLOWED_TAGS: [
        'p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'strike',
        'a', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'blockquote',
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel'],
    ALLOW_DATA_ATTR: false,
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
};

let hooksInstalled = false;

function ensureLinkHooks(): void {
    if (hooksInstalled || typeof window === 'undefined') return;
    hooksInstalled = true;
    DOMPurify.addHook('afterSanitizeAttributes', (node) => {
        if (node.nodeName !== 'A') return;
        const el = node as HTMLAnchorElement;
        const href = el.getAttribute('href') || '';
        if (href.startsWith('javascript:') || href.startsWith('data:')) {
            el.removeAttribute('href');
            return;
        }
        if (el.getAttribute('target') === '_blank') {
            el.setAttribute('rel', 'noopener noreferrer');
        }
    });
}

/** Safe HTML for login “Sign In terms notice” (admin-controlled). */
export function sanitizeLoginSignInTermsHtml(dirty: string): string {
    ensureLinkHooks();
    return DOMPurify.sanitize(dirty, SANITIZE_OPTIONS);
}
